import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

import { setFlashMessage, useWebsite } from './WebsiteContext';
import config from '../config/config';
import Loader from '../components/Loader';

const { apiUrl } = config; 
const RestoContext = createContext();

export const useResto = () => {
    return useContext(RestoContext);
  };

export const RestoProvider = ({ children }) => {
    const [restoData, setRestoData] = useState(null);
    const { website } = useWebsite();
    const [isLoading, setIsLoading] = useState(false);
  
    useEffect(() => {
        const mainColor = restoData ? `rgb(${restoData.mainColor})` : 'rgba(0,0,0,1)';
        const mainColor90 = restoData ? `rgba(${restoData.mainColor},0.9)` : 'rgb(0,0,0,0.9)';
        const mainColor80 = restoData ? `rgba(${restoData.mainColor},0.8)` : 'rgb(0,0,0,0.8)';
        const mainColor70 = restoData ? `rgba(${restoData.mainColor},0.7)` : 'rgb(0,0,0,0.7)';
        const mainColor60 = restoData ? `rgba(${restoData.mainColor},0.6)` : 'rgb(0,0,0,0.6)';
        const color2 = restoData ? `rgb(${restoData.color2})` : 'rgba(255,255,255,1)';
        const color3 = restoData ? `rgb(${restoData.color3})` : 'rgba(255,255,255,1)';
        document.documentElement.style.setProperty('--main-color', mainColor);
        document.documentElement.style.setProperty('--color2', color2);
        document.documentElement.style.setProperty('--color3', color3);
        document.documentElement.style.setProperty('--main-color-90', mainColor90);
        document.documentElement.style.setProperty('--main-color-80', mainColor80);
        document.documentElement.style.setProperty('--main-color-70', mainColor70);
        document.documentElement.style.setProperty('--main-color-60', mainColor60);
    }, [restoData]);

    useEffect(() => {  
      const fetchRestoData = async () => {
        try {
          const response = await axios.get(`${apiUrl}resto/${website}`);
          setRestoData(response.data);

          if (restoData && restoData.hasFavicon) {
            const faviconUrl = `${config.documentsUrl}logos/favicon.png`;
            updateFavicon(faviconUrl);
          }
        } catch (error) {
          setFlashMessage("Une erreur s'est produite", 'error');
          console.error('Error fetching restaurant data:', error);
        }
      };
  
      if (website) {
        fetchRestoData();
      }
  
    }, [website]);
  
    const updateFavicon = (url) => {
        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon) {
            favicon.href = url;
        }
    };

    return (
      <RestoContext.Provider value={{ restoData, setIsLoading, setRestoData }}>
        {children}
        {isLoading && <Loader />}
      </RestoContext.Provider>
    );
  };
  